import axiosInstance from './axiosInstance';

export const customYoutubeApi = {
  // Public endpoints (no auth required)
  getAll: async () => {
    try {
      const response = await axiosInstance.get('/custom-youtube');
      console.log('Custom YouTube API response:', {
        status: response.status,
        data: response.data,
        isArray: Array.isArray(response.data)
      });
      return response;
    } catch (error) {
      console.error('Custom YouTube API error:', error);
      throw error;
    }
  },

  getByCustomId: async (customVideoId) => {
    return await axiosInstance.get(`/custom-youtube/video/${customVideoId}`);
  },

  getQRCode: async (customVideoId) => {
    return await axiosInstance.get(`/custom-youtube/video/${customVideoId}/qr`);
  },

  // Legacy methods (for backward compatibility)
  getById: (id) => axiosInstance.get(`/custom-youtube/${id}`),
  create: (video) => axiosInstance.post('/custom-youtube', video),
  update: (id, video) => axiosInstance.put(`/custom-youtube/${id}`, video),
  delete: (id) => axiosInstance.delete(`/custom-youtube/${id}`),

  // Admin endpoints (require admin permissions)
  admin: {
    getAll: async () => {
      return await axiosInstance.get('/custom-youtube/admin/all');
    },

    create: async (videoData) => {
      return await axiosInstance.post('/custom-youtube/admin', videoData);
    },

    update: async (customVideoId, videoData) => {
      return await axiosInstance.put(`/custom-youtube/admin/${customVideoId}`, videoData);
    },

    delete: async (customVideoId) => {
      return await axiosInstance.delete(`/custom-youtube/admin/${customVideoId}`);
    }
  }
};

export default customYoutubeApi;